module.exports = require("hemera-plugin");